/**
 * Copyright (c) 2016 Hideki Shiro
 */

module.exports = require('./build/src/index.js');
